import React from "react";

const colors = ["#0073ea", "#9c58f3", "#00c875", "#fdab3d"];
const initials = ["J", "S", "M", "A"];

const Testimonial = () => {
  return (
    <div className="flex gap-2 items-center mb-8">
      <div className="flex -space-x-1.5">
        {colors.map((c, i) => (
          <div
            key={i}
            className="w-6 h-6 rounded-full border-2 border-solid border-white flex items-center justify-center text-[9px] text-white font-bold"
            style={{ backgroundColor: c }}
          >
            {initials[i]}
          </div>
        ))}
      </div>
      <span className="text-[11px] text-[#676879]">
        Trusted by <strong className="text-[#323338]">10,000+</strong> teams on monday.com
      </span>
    </div>
  );
};

export default Testimonial;
